var render, staticRenderFns
import script from "./Communicator.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Communicator.vue?vue&type=script&lang=ts"
export * from "./Communicator.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Communicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports